const Layout = () => import('@/components/Layout/Layout.vue');
const Home = () => import('@/components/pages/Home/Home.vue');

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'home',
        alias: '',
        component: Home,
        name: 'home',
        meta: {}
      }
    ]
  }
];

export default routes;
